/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import { WTitle, CTitle } from '../../components/Widget';
import personTab from '../../../../../../assets/2025/topic900/tab/person_tab.png';
import elePersonLeft from '../../../../../../assets//2025/topic900/elePerson_2_1.png';
import elePersonRight from '../../../../../../assets//2025/topic900/elePerson_2_2.png';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import { Tabs, Radio } from 'antd';
import Quiz from '../../components/Quiz';
import { useUpdateComponentState } from '../../../hooks';

interface ISection4Props {
  settings: any;
}

const { TabPane } = Tabs;
const Section4: React.FunctionComponent<ISection4Props> = ({ settings }) => {
  const ID = '5';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[4],
    [settings?.paragraphs]
  );
  const [state, setState] = useState({
    case1: { state: false, num: 0 },
    case2: { state: true, num: 1 },
    case3: { state: false, num: 1 },
    step1: { state: false, num: 0 },
    step2: { state: true, num: 1 },
    step3: { state: false, num: 1 },
    step4: { state: false, num: 1 },
    verify1: { state: false, num: 0 },
    verify2: { state: true, num: 1 },
    verify3: { state: false, num: 1 },
    verify4: { state: false, num: 1 },
    quiz: { state: false, num: 1 },
  });
  type keyObj = {
    case1: { state: boolean; num: number };
    case2: { state: boolean; num: number };
    case3: { state: boolean; num: number };
    step1: { state: boolean; num: number };
    step2: { state: boolean; num: number };
    step3: { state: boolean; num: number };
    step4: { state: boolean; num: number };
    verify1: { state: boolean; num: number };
    verify2: { state: boolean; num: number };
    verify3: { state: boolean; num: number };
    verify4: { state: boolean; num: number };
    quiz: { state: boolean; num: number };
  };
  const [tabValue, setTabValue] = useState('1');
  const [step, setStep] = useState(0);
  const [verify, setVerify] = useState(0);
  const { updateParagraphState } = useStore();
  const { quiz } = paragraphsSettings;
  const updateComponentState = useUpdateComponentState();
  React.useEffect(() => {
    const resultArray = Object.keys(state).map((key) => ({
      key,
      ...state[key as keyof keyObj],
    }));
    const caseIndex = resultArray.filter(item=>item.key.indexOf('case')!=-1).findIndex((subitem) => subitem.num === 1 || subitem.state);
    if(caseIndex=== -1){
      updateComponentState(p_course, p_topic, ID, '2025-topic900-section4-1');
    }
    const stepIndex = resultArray.filter(item=>item.key.indexOf('step')!=-1).findIndex((subitem) => subitem.num === 1 || subitem.state);
    if(stepIndex=== -1){
      updateComponentState(p_course, p_topic, ID, '2025-topic900-section4-2');
    }
    const verifyIndex = resultArray.filter(item=>item.key.indexOf('verify')!=-1).findIndex((subitem) => subitem.num === 1 || subitem.state);
    if(verifyIndex=== -1){
      updateComponentState(p_course, p_topic, ID, '2025-topic900-section4-3');
    }
    // console.log(caseIndex,'===resultArray',resultArray)
    // if (index === -1) {
    //   updateParagraphState(p_course, p_topic, ID, 'completed', []);
    // }
  }, [state]);
  const getImg = (i: string, n: number) =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require(`./../../../../../../assets/2025/topic900/tab/tab${i}_${n}.png`)
      .default;
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const getStepImg = (step: string) =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require(`./../../../../../../assets/2025/topic900/step/step${step}.png`)
      .default;
  const getVerifyImg = (i: string) =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require(`./../../../../../../assets/2025/topic900/verify/verify_icon${i}.png`)
      .default;
  const getVerifyBg = (i: string) =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require(`./../../../../../../assets/2025/topic900/verify/verify_bg${i}.png`)
      .default;
  const stepChange = ({ target: { value } }: any) => {
    setStep(value);
    const num = Number(value) + 1;
    state[`step${num}` as keyof keyObj].state = false;
    state[`step${num}` as keyof keyObj].num = 0;
    if (state[`step${num + 1}` as keyof keyObj]?.num === 1) {
      state[`step${num + 1}` as keyof keyObj].state = true;
    }
    setState({ ...state });
  };
  const onVerifyChange = (i: number) => {
    setVerify(i);
    const num = i + 1;
    state[`verify${num}` as keyof keyObj].state = false;
    state[`verify${num}` as keyof keyObj].num = 0;
    if (state[`verify${num + 1}` as keyof keyObj]?.num === 1) {
      state[`verify${num + 1}` as keyof keyObj].state = true;
    }
    setState({ ...state });
  };
  const changeState = (activeKey: string) => {
    setTabValue(activeKey);
    state[`case${activeKey}` as keyof keyObj].state = false;
    state[`case${activeKey}` as keyof keyObj].num = 0;
    if (state[`case${Number(activeKey) + 1}` as keyof keyObj]?.num === 1) {
      state[`case${Number(activeKey) + 1}` as keyof keyObj].state = true;
    }
    setState({ ...state });
  };
  return (
    <div className="topic-section-4">
      <WTitle title={paragraphsSettings.title} />
      {/*<CTitle title={paragraphsSettings.title} />*/}
      <div className="mv">
        <div className="mv-left">
          <img className="mv-left-person" src={elePersonLeft} alt="" />
          <div
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.top?.left,
            }}
          />
        </div>
        <div className="mv-right">
          <img className="mv-right-person" src={elePersonRight} alt="" />
          <div

            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.top?.right,
            }}
          />
        </div>
      </div>
      <div className="case">
        <WTitle title={paragraphsSettings.tabTitle} />
        <div id="2025-topic900-section4-1" className={`case-tab tab${tabValue}`}>
          <img className="person_tab" src={personTab} alt="" />
          <Tabs
            type="card"
            centered={true}
            onChange={changeState}
          >
            {paragraphsSettings?.tab?.map(
              (
                item: {
                  title: string;
                  content: string;
                  subTitle1: string;
                  subTitle2: string;
                  subTitle3: string;
                },
                i: any
              ) => (
                <TabPane
                  tab={
                    tabValue == i + 1 ? (
                      <>
                        <h1>{`0${i + 1}`}</h1>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: item.title,
                          }}
                        />
                      </>
                    ) : (
                      <>
                        {state?.[`case${i + 1}` as keyof keyObj].state && (
                          <img
                            className={`imgPoint_${i + 1}`}
                            src={ImgPoint}
                            alt=""
                          />
                        )}
                        <h3>{`0${i + 1}`}</h3>
                      </>
                    )
                  }
                  key={i + 1}
                >
                  <div className="case-tab-content"> {item.content}</div>
                  <div className={`case-bottom case-bottom${i + 1}`}>
                    <div className="case-item1">
                      <div className="subTitle">{item.subTitle1}</div>
                      <img src={getImg(i + 1, 1)} alt="" />
                    </div>
                    <div className="case-item2">
                      <div className="subTitle">{item.subTitle2}</div>
                      <img src={getImg(i + 1, 2)} alt="" />
                    </div>
                    {item?.subTitle3 && (
                      <div className="case-item3">
                        <div className="subTitle">{item.subTitle3}</div>
                        <img src={getImg(i + 1, 3)} alt="" />
                      </div>
                    )}
                  </div>
                </TabPane>
              )
            )}
          </Tabs>
        </div>
      </div>
      <div className="step">
        <CTitle title={paragraphsSettings.stepsTitle} />
        <div id="2025-topic900-section4-2" className="step-tab">
          <Radio.Group
            onChange={stepChange}
            value={step}
            optionType="button"
            buttonStyle="solid"
          >
            {paragraphsSettings?.steps?.map(
              // eslint-disable-next-line @typescript-eslint/no-shadow
              (step: { title: string; tips: string }, i: number) => (
                <Radio.Button key={i} value={i}>
                  {state?.[`step${i + 1}` as keyof keyObj].state && (
                    <img className="stepPoint" src={ImgPoint} alt="" />
                  )}
                  {step.title}
                </Radio.Button>
              )
            )}
          </Radio.Group>
          <div className="step-tab-content">
            <img
              className={`img0 img${step + 1}`}
              src={getStepImg(String(step + 1))}
              alt=""
            />
            <span className={`step0 step${step + 1}`}>
              {paragraphsSettings?.steps[step]?.tips}
            </span>
          </div>
        </div>
      </div>
      <div className="verify">
        <div className="verify-title">
          <CTitle title={paragraphsSettings?.verifyTitle} />
          <span className="subtitle">{paragraphsSettings?.verifySubtitle}</span>
        </div>
        <div id="2025-topic900-section4-3" className="verify-card-bg">
          <div className="verify-card">
            {paragraphsSettings?.verifyList?.map(
              (item: { title: string; content: string }, i: number) =>
                verify === i ? (
                  <div
                    className={`verify-card-active active${verify + 1}`}
                    key={i}
                  >
                    <div className="active-top">
                      <img src={getVerifyBg(String(i + 1))} alt="" />
                      <h3>{item.title}</h3>
                    </div>
                    <div className="active-bottom">
                      <p>{item.content}</p>
                    </div>
                  </div>
                ) : (
                  <div
                    className="verify-card-item"
                    onClick={() => onVerifyChange(i)}
                    key={i}
                  >
                    <div className="item-top">
                      {state?.[`verify${i + 1}` as keyof keyObj].state && (
                        <img className="verifyPoint" src={ImgPoint} alt="" />
                      )}
                      <img src={getVerifyImg(String(i + 1))} alt="" />
                      <p>{item.title}</p>
                    </div>
                    <div className="item-bottom">{item.content}</div>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
      <div id="2025-topic900-section4-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            state[`quiz` as keyof keyObj].num = 0;
            setState({ ...state });
            updateComponentState(p_course, p_topic, ID, '2025-topic900-section4-question');
            // updateParagraphState(p_course, p_topic, ID, 'completed', []);
          }}
        />
      </div>
    </div>
  );
};

export default Section4;
